export default "__VITE_ASSET__BU__oU34__"